export default __webpack_public_path__ + "static/media/codelist.339ff0b8.png";